import React from 'react';
import { Link } from 'react-router-dom';
import { ENV } from '../config/env';

const BRAND_NAME = ENV.APP.NAME;

/**
 * PetsFostering logo — monoline SVG from brand artwork.
 * Icon + wordmark share one color via currentColor.
 */
export const LogoMark = ({
  size = 40,
  className = '',
  title = BRAND_NAME,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="30.32 21.48 150.68 150.52"
    fill="currentColor"
    fillRule="evenodd"
    clipRule="evenodd"
    xmlns="http://www.w3.org/2000/svg"
    className={`pf-logo-mark shrink-0 ${className}`}
    role="img"
    aria-label={title}
  >
    <path d="M65.99,166.25 C65.98,165.29 65.08,161.65 63.99,158.16 C60.78,147.94 61.43,139.99 66.47,127.81 C66.94,126.67 66.33,125.41 64.58,123.88 C61.36,121.09 61.37,120.53 64.66,116.64 C66.12,114.91 68.37,111.13 69.65,108.24 C72.37,102.11 76.62,99.01 82.32,99.00 C87.18,99.00 89.53,100.27 94.57,105.65 C97.03,108.28 99.53,110.00 100.89,110.00 C105.03,110.00 107.09,111.79 106.38,114.79 C105.21,119.74 102.20,122.00 96.76,122.00 C90.14,122.00 88.00,123.29 88.01,127.29 C88.02,133.25 90.07,137.98 95.30,144.08 C104.33,154.62 105.86,157.01 107.10,162.57 L108.32,168.00 L134.74,168.00 L161.15,168.00 L164.08,165.08 L167.00,162.15 L167.00,126.08 L167.00,90.00 L169.37,90.00 C173.32,90.00 177.00,86.35 177.00,82.44 C177.00,79.27 176.14,78.34 165.25,69.69 C140.07,49.71 110.40,27.23 108.38,26.61 C104.76,25.48 101.36,27.57 81.26,43.27 C70.53,51.65 57.20,62.02 51.63,66.32 C39.13,75.96 37.02,77.90 35.92,80.75 C34.32,84.90 38.53,90.00 43.55,90.00 C44.79,90.00 45.00,95.07 45.00,125.07 C45.00,148.92 45.36,160.83 46.12,162.32 C48.38,166.75 51.08,167.95 58.75,167.98 C65.00,168.00 66.00,167.76 65.99,166.25 ZM52.00,162.02 C50.72,161.22 50.43,155.41 50.00,123.29 L49.50,85.50 L45.83,85.19 C41.97,84.87 39.63,83.12 40.81,81.44 C41.19,80.90 53.65,71.04 68.50,59.53 C83.35,48.02 97.70,36.90 100.38,34.80 C103.06,32.71 105.64,31.00 106.10,31.00 C107.03,31.00 119.00,39.99 146.50,61.33 C174.21,82.84 173.25,82.00 171.92,83.60 C171.28,84.37 169.06,85.00 166.98,85.00 C164.47,85.00 163.01,85.53 162.61,86.58 C162.27,87.45 162.00,104.50 162.00,124.46 C162.00,155.50 161.78,160.94 160.50,162.00 C159.20,163.08 159.00,162.46 159.00,157.24 C159.00,150.54 157.42,146.03 152.50,138.73 L149.17,133.77 L151.10,130.64 C152.79,127.90 152.97,126.28 152.46,118.00 C152.14,112.78 151.68,107.49 151.42,106.25 C150.79,103.18 146.99,103.29 143.18,106.50 C139.18,109.87 133.57,109.87 129.00,106.50 C122.80,101.93 119.59,104.22 120.11,112.84 C120.26,115.40 120.04,119.42 119.60,121.77 C118.97,125.20 119.23,126.82 120.91,130.05 L123.00,134.06 L120.90,140.28 C118.64,147.01 118.83,153.27 121.51,159.67 L122.90,163.00 L117.45,163.00 C113.76,163.00 112.00,162.60 111.99,161.75 C111.97,158.54 106.51,149.34 101.55,144.14 C96.10,138.43 93.00,132.95 93.00,129.03 C93.00,127.35 93.65,127.00 96.75,127.00 C105.00,127.00 111.00,120.80 111.00,112.29 L111.00,108.06 L105.25,106.38 C100.80,105.09 98.64,103.73 95.68,100.38 C86.83,90.32 72.27,92.51 66.35,104.80 C64.84,107.94 62.12,112.48 60.30,114.89 C56.38,120.11 56.28,121.06 59.29,124.55 L61.58,127.21 L59.32,133.86 C56.68,141.60 56.38,149.65 58.49,156.59 C59.31,159.29 59.98,161.84 59.99,162.25 C60.00,163.33 53.78,163.15 52.00,162.02 ZM125.68,157.66 C123.45,150.59 123.55,146.73 126.14,139.36 L128.29,133.22 L126.11,130.15 C124.10,127.33 123.98,126.34 124.61,117.99 L125.29,108.91 L127.90,111.32 C131.48,114.63 140.69,114.58 144.26,111.23 C147.67,108.02 148.35,108.44 147.67,113.38 C147.34,115.79 147.50,119.26 148.02,121.09 C148.79,123.74 148.58,125.25 146.99,128.52 C145.90,130.78 145.01,133.28 145.02,134.07 C145.03,134.85 147.03,138.81 149.46,142.86 C154.43,151.12 155.49,154.59 154.55,159.58 L153.91,163.00 L140.64,163.00 L127.37,163.00 L125.68,157.66 ZM84.95,128.57 C86.60,126.57 85.90,120.50 84.01,120.50 C83.20,120.50 82.36,121.40 82.16,122.50 C81.96,123.60 81.12,125.26 80.30,126.19 C79.48,127.11 79.10,128.35 79.46,128.94 C80.40,130.46 83.55,130.25 84.95,128.57 ZM116.51,84.75 C122.44,78.87 125.12,75.42 125.83,72.75 C128.70,62.04 118.23,53.21 109.08,58.61 C106.56,60.10 106.09,60.10 103.22,58.61 C91.24,52.42 80.83,66.52 88.96,77.94 C91.97,82.16 104.67,93.00 106.62,93.00 C107.48,93.00 111.93,89.29 116.51,84.75 ZM98.53,80.82 C91.61,74.03 91.00,73.11 91.00,69.37 C91.00,64.48 93.30,62.00 97.84,62.00 C99.98,62.00 101.72,62.81 103.19,64.50 C105.88,67.60 106.73,67.62 109.08,64.62 C111.51,61.54 113.98,60.95 117.80,62.56 C120.16,63.55 121.04,64.69 121.55,67.40 C122.43,72.11 120.24,75.73 112.28,82.73 L106.06,88.20 L98.53,80.82 Z" />
  </svg>
);

const VARIANT_CLASS = {
  brand: 'pf-logo--brand',
  light: 'pf-logo--light',
  dark: 'pf-logo--dark',
};

const Logo = ({
  to = '/',
  size = 40,
  showText = true,
  text = BRAND_NAME,
  variant = 'brand',
  className = '',
  onClick,
  title,
}) => {
  const content = (
    <>
      <LogoMark size={size} title={title || text} />
      {showText && <span className="pf-logo__text">{text}</span>}
    </>
  );

  const baseClass = [
    'pf-logo',
    'inline-flex',
    'items-end',
    'group',
    VARIANT_CLASS[variant] || VARIANT_CLASS.brand,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const style = { '--pf-logo-size': `${size}px` };

  if (to) {
    return (
      <Link
        to={to}
        className={baseClass}
        style={style}
        onClick={onClick}
        title={title || text}
      >
        {content}
      </Link>
    );
  }

  return (
    <span
      className={baseClass}
      style={style}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
    >
      {content}
    </span>
  );
};

export default Logo;
